<template>
    <TransitionRoot as="template" @close="close()" :show="open">
        <Dialog as="div" static class="fixed z-30 inset-0 overflow-y-auto | ffq-quiz-dialog " :open="open" >
            <div class="flex items-start justify-center min-h-screen pt-10 px-4 pb-20 text-center sm:block sm:p-0 sm:px-4 sm:pt-4" ref="dialog">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-80 transition-opacity" />
                </TransitionChild>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                    <div class="inline-block align-top bg-white rounded-3xl text-left overflow-hidden shadow-2xl  transform transition-all
                     | sm:my-8" :class="[widthClass]">
                        <div ref="funnelQuiz">
                            <FunnelQuiz :quizData="quizData"/>
                        </div>
<!--                        <div class="mt-5 sm:mt-6">-->
<!--                            <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-yellow-600 text-base font-medium text-white hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400 sm:text-sm"-->
<!--                                    @click="close()" v-text="'Sluiten'"></button>-->
<!--                        </div>-->
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<style lang="scss">
    .modal-quiz{
        width: 100%;
        max-width: 320px;
        @media(min-width: 640px) {
            max-width: 500px;
        }
        @media(min-width: 768px){
            max-width: 600px;
        }

        @media(min-width: 1024px){
            max-width: 900px;
        }


        @media(min-width: 1536px){
            max-width: 1320px;
        }
    }
    .modal-finished{
        @media(min-width: 768px){
            max-width: 600px;
        }
        @media(min-width: 1024px){
            max-width: 700px;
        }
        @media(min-width: 1536px){
            max-width: 896px;
        }
    }
</style>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import FunnelQuiz from "./FunnelQuiz";
import {useStore} from "vuex";
import {computed} from "vue";
import {ViewStates} from "../Store/ViewStates";
const viewStates = ViewStates;

export default {
    name: "DialogContainer",
    data(){
        return {

        }
    },
    components: {
        FunnelQuiz,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },
    watch: {
        currentPage(newPage, prevPage) {
            this.$refs.dialog.scrollIntoView({behavior: "smooth"});
        }
    },
    setup(props){
        const store = useStore()

        return {
            currentPage: computed(() => store.state.currentPageNumber),
            open: computed(() => store.state.dialogOpened),
            viewState: computed(() => store.state.viewState),
            close: () => { store.commit('closeDialog');},
            viewStates: viewStates
        }
    },
    computed: {
      widthClass(){
          if(this.viewState === viewStates.FINISHED){
              return ['modal-finished'];
          }

          return ['modal-quiz']; //'sm:max-w-5xl' 'sm:w-full'
      }
    },
    methods: {

    },
    props: {
        quizData: {
            type: Object,
            required: true,
        },
    }
}
</script>
